import React, { useState } from 'react'
import { Form, Input, Button, Row, Col, Divider, message, Tooltip, Icon } from 'antd';
import { Link, useHistory } from 'react-router-dom'
import { useLazyQuery } from "@apollo/react-hooks";
import { REGISTER_QUERY } from '../../constants/graphql-query';
import Captcha from '../form/Captcha';
import { useTranslation } from 'react-i18next';

const Register = (props) => {

  const [auth, { data }] = useLazyQuery(REGISTER_QUERY, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });
  let history = useHistory();

  const { t } = useTranslation();

  const { getFieldDecorator } = props.form;

  const [isFormCliked, changeStatus] = useState(false)

  const handleSubmit = e => {
    e.preventDefault();
    changeStatus(!isFormCliked);

    props.form.validateFields((err, fieldsValue) => {
      if (err) {
        return;
      }

      message.loading('Please wait..', 0);

      auth({
        variables: {
          firstName: fieldsValue["first-name"],
          lastName: fieldsValue["last-name"],
          country: fieldsValue["country"],
          logonId: fieldsValue["email"],
          password: fieldsValue["password"],
          registerOrg: fieldsValue["organization"]
        }
      })
      props.form.setFieldsValue({ "captcha": "" })
    });
  };

  if (data && data.registration) {
    if (data.registration.code === '200') {
      message.destroy();
      message.success("Registered Successfully");
      history.push('/login')
    }
  }

  const config = (input, extraRules = []) => ({
    rules: [].concat(extraRules, [{ required: true, message: `Please Enter ${input}` }]),
  });


  const validatePassword = (rule, value, callback) => {
    const { form } = props;
    const password = form.getFieldValue("password");
    const matchpassword = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{10,128}$/;
    if (password && !password.match(matchpassword)) {
      callback(t("form.passwordPolicy"));
    }

    callback();
  };

  return (
    <Row type="flex" align="middle" justify="center" gutter={[0, 8]}>
      <Col span={6}>
        <Row>
          <Col span={24}>
            <h3><strong>Sign Up</strong></h3>
          </Col>
          <Col span={24}>
            <Form layout="vertical" className="registration-form" onSubmit={handleSubmit}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item label="First Name:">
                    {
                      getFieldDecorator(
                        'first-name',
                        config(
                          'First Name',
                          [{
                            type: "string",
                            pattern: /^[a-z0-9A-Z\s\w_-]+$/,
                            message: 'Please enter valid Input',
                          }]
                        )
                      )(<Input autoComplete="off" />)
                    }
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Last Name:">
                    {
                      getFieldDecorator(
                        'last-name',
                        config(
                          'Last Name',
                          [{
                            type: "string",
                            pattern: /^[a-z0-9A-Z\s\w_-]+$/,
                            message: 'Please enter valid Input',
                          }]
                        )
                      )(<Input autoComplete="off" />)}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Email:">
                    {
                      getFieldDecorator(
                        'email',
                        config(
                          'Email',
                          [{ 
                            type: "email",
                            message: 'The input is not valid E-mail!',
                          }]
                        )
                      )(<Input autoComplete="off" />)}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Password:">
                    {getFieldDecorator('password', config("Password", {
                      validator: validatePassword
                    }))(
                      <Input type="password" suffix={
                        <Tooltip title={t("form.passwordPolicy")}>
                          <Icon type="info-circle" />
                        </Tooltip>
                    }/>)}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Country:">
                    {
                      getFieldDecorator(
                        'country',
                        config(
                          'Country',
                          [{
                            type: "string",
                            pattern: /^[a-z0-9A-Z\s\w_-]+$/,
                            message: 'Please enter valid Input',
                          }]
                        )
                      )(<Input autoComplete="off" />)
                    }
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Organization:">
                    {
                      getFieldDecorator(
                        'organization',
                        config(
                          'Organization',
                          [
                            {
                              type: "string",
                              pattern: /^[a-z0-9A-Z\s\w_-]+$/,
                              message: 'Please enter valid Input',
                            }
                          ]
                        )
                      )(<Input autoComplete="off" />)
                    }
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Captcha form={props.form} isSubmitted={isFormCliked} />
                </Col>
                <Col span={24}>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" className="primary-dark">Sign Up</Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
      <Col span={4} align="center">
        <Divider className="vertical-line" type="vertical" />
      </Col>
      <Col span={6} align="center">
        <h3>Already have a account? <Link to={"/login"}>Sign In</Link></h3>
        {/* <h4><a href="#"><small>Contact Us</small></a> <Divider type="vertical" /> <a href="#"><small>More Information</small></a></h4> */}
      </Col>
    </Row>
  )
}

const RegisterForm = Form.create({ name: 'register_form' })(Register);
export default RegisterForm;